import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const LoadingSpinner: React.FC = () => (
  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '60vh' }}>
    <CircularProgress />
    <Typography variant="body2" sx={{ mt: 2 }}>Loading...</Typography>
  </Box>
);

export default LoadingSpinner;
